import styled from '@emotion/styled'

export const StyleFormGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const StyleImageRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  column-gap: 15px;
  row-gap: 15px;
`

export const StyleWorkWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

export const StyleWorkItem = styled.li`
  list-style: disc;
  font-size: 18px;
  margin-left: 15px;
  color: ${(props: any) => props.theme.colors.secondary};
`
